import * as Stimulus from "@hotwired/stimulus"
import AirDatepicker from "air-datepicker"
import localeEn from "air-datepicker/locale/en"
import "air-datepicker/air-datepicker.css"

export class DatepickerController extends Stimulus.Controller {
    static values = {
        inline: { type: Boolean, default: true },
        initialDate: String,
    }

    static get targets() {
        return ['input', 'dateList'];
    }

    connect() {
        if (this.inlineValue) {
            this.inputTarget.type = "hidden";
        }
        let legalDates = [...this.dateListTarget.options]
            .map(option => dateFromInputValue(option.value))
            .filter(Boolean);

        let selectedDate;
        if (this.inputTarget.value) {
            selectedDate = dateFromInputValue(this.inputTarget.value);
        }
        let initialDate = this.hasInitialDateValue
            ? dateFromInputValue(this.initialDateValue)
            : undefined;
        let startDate = selectedDate || initialDate || legalDates[0];

        this.picker = new AirDatepicker(this.inputTarget, {
            locale: localeEn,
            inline: this.inlineValue,
            toggleSelected: !this.inputTarget.required,
            dateFormat: "yyyy-MM-dd",
            selectedDates: selectedDate ? [selectedDate] : false,
            startDate,
            onRenderCell({ date }) {
                return {
                    disabled: !legalDates.find(legalDate => sameDate(legalDate, date))
                }
            },
            onSelect: ({ date }) => {
                this.dispatch("date-selected", { detail: { date } });
            }
        });

        if (selectedDate) {
            this.dispatch("date-selected", { detail: { date: selectedDate } });
        }
    }

    disconnect() {
        this.picker.destroy();
    }
}

function dateFromInputValue(value) {
    let [year, month, day] = value.split("-").map(Number);

    if (!year || !month || !day) {
        return undefined;
    }

    return new Date(year, month - 1, day);
}

function sameDate(date1, date2) {
    return date1.getDate() === date2.getDate()
        && date1.getFullYear() === date2.getFullYear()
        && date1.getMonth() === date2.getMonth();
}
